import React, { useEffect, useState, useCallback, useRef } from 'react';
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Stack,
  useColorModeValue,
  Text,
  Grid,
  Table,
  Tbody,
  useDisclosure,
  Th,
  Thead,
  Tr,
  RadioGroup,
  Radio,
  Modal,
  ModalContent,
  ModalBody,
  ModalOverlay,
  ModalHeader,
  ModalCloseButton,
  Portal,
  Box,
  Select,
  Textarea,
  useToast,
  Skeleton,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  IconButton,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForm, Controller } from 'react-hook-form';
import {
  listChannelAtom,
  listUnitAtom,
  paymentStatusListAtom,
} from 'state/show';
import { useRecoilValue } from 'recoil';
import { Select as ReSelect } from 'chakra-react-select';
import { HSeparator } from 'components/Separator/Separator';
import { useBookingActions } from 'hooks/useBookingActions';
import TablesTableRow from 'components/Tables/TablesTableRow';
import { QrCodeIConMobile } from 'components/Icons/Icons';
import { QrScanner } from '@yudiel/react-qr-scanner';
import { useRatePlanActions } from 'hooks/useRatePlanActions';
import { selectedShowAtom } from 'state/show';
import RatePlanCard from 'components/RatePlanCard/RatePlanCard';
import CountDown from 'components/CountDown/CountDown';
import ComboCard from 'components/ComboCard/ComboCard';
import { useHistory, Prompt } from 'react-router-dom';
import moment from 'moment';
import { showTextFloor } from 'variables/columnsData';
import { CUSTOMER_DISPLAY_CHANNEL_NAME } from 'helpers/customerDisplayChannel';
import { isOfficialPriceChannelGroup } from 'helpers/helpers';
import CustomerDisplayPreview from './CustomerDisplayPreview';
import { NumericFormat } from 'react-number-format';
import ReactDatePicker from 'react-datepicker';

function BookingPayment() {
  const textColor = useColorModeValue('gray.700', 'white');
  const listChannel = useRecoilValue(listChannelAtom);
  const listUnit = useRecoilValue(listUnitAtom);
  const selectedShow = useRecoilValue(selectedShowAtom);
  const bookingActions = useBookingActions();
  const ratePlanActions = useRatePlanActions();
  const [bookingInfo, setBookingInfo] = useState();
  const [listRatePlan, setListRatePlan] = useState([]);
  const [listCombo, setListCombo] = useState([]);
  const [showQRCode, setShowQRCode] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [depositValue, setDepositValue] = useState(0);
  const [totalRemain, setTotalRemain] = useState('');
  const [selectedRatePlan, setSelectedRatePlan] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [isCancelling, setIsCancelling] = useState(false);
  const [selectedCombo, setSelectedCombo] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [unitSearchResults, setUnitSearchResults] = useState([]);
  const listPaymentStatus = useRecoilValue(paymentStatusListAtom);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const history = useHistory();
  const toast = useToast();
  const [shouldBlockNavigation, setShouldBlockNavigation] = useState(true);
  const [isLeaveDialogOpen, setIsLeaveDialogOpen] = useState(false);
  const [pendingLocation, setPendingLocation] = useState(null);
  const [isNavigating, setIsNavigating] = useState(false);
  const leaveRef = useRef();
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const cancelRef = useRef();
  const isProgrammaticNavigation = useRef(false);
  const isSettingChannelFromUnit = useRef(false);
  const customerDisplayChannelRef = useRef(null);

  // Channel used to push the booking code to the Customer Display once
  // createBooking() below actually creates the booking in the database.
  useEffect(() => {
    customerDisplayChannelRef.current = new BroadcastChannel(
      CUSTOMER_DISPLAY_CHANNEL_NAME
    );
    return () => customerDisplayChannelRef.current?.close();
  }, []);

  // Send the Customer Display back to its idle/welcome screen if the seat
  // hold expires or the booking session is cancelled while still on this
  // Unit/Rateplan step — no booking was ever created, so the confirmation
  // it's showing is stale.
  function resetCustomerDisplay() {
    // Tag the reset with this session's expireAt so the display can tell it
    // apart from an unrelated booking's cancel/expiry — see the matching
    // guard in BookingCustomerDisplay.js.
    customerDisplayChannelRef.current?.postMessage({
      type: 'idle',
      expireAt: selectedShow?.booking?.expire_at,
    });
  }

  const validationSchema = Yup.object().shape({});
  const formOptions = { resolver: yupResolver(validationSchema) };
  const {
    register,
    handleSubmit,
    setValue,
    formState,
    reset,
    control,
    watch,
    setError,
    clearErrors,
  } = useForm(formOptions);
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const channel = watch('channel');
  const unit = watch('unit');
  const deposit = watch('deposit');
  const paymentStatus = watch('payment_status');
  const paymentMethodWatch = watch('payment_method');
  const voucher_code = watch('promotion_code');
  console.log(paymentStatus, 'paymentStatus');

  // Some channel groups (e.g. B2B/agency) have their own agreed rate plan
  // Amount that isn't meant to be shown to the guest at the counter — show
  // the zone's Official Price on the Customer Display instead for those.
  const showOfficialPriceOnDisplay = isOfficialPriceChannelGroup(channel?.channel_group_id);

  // Rate plans price children differently from adults (see the
  // Official Price vs Amount columns below), so the naive zone-based
  // estimate the Customer Display started with is no longer accurate once a
  // rate plan is applied. Push the real per-seat amounts so it can replace
  // that estimate with the actual charge.
  useEffect(() => {
    if (!bookingInfo?.calculator?.length) return;
    customerDisplayChannelRef.current?.postMessage({
      type: 'payment-summary',
      data: {
        rows: bookingInfo.calculator.map((row) => ({
          seatNumber: row.seat_number,
          zone: row.zone,
          programApplied: row.program_apply,
          officialPrice: row.official_price,
          amount: showOfficialPriceOnDisplay ? row.official_price : row.amount,
        })),
        total: showOfficialPriceOnDisplay
          ? bookingInfo.calculator.reduce((acc, curr) => acc + (curr.official_price || 0), 0)
          : totalAmount,
      },
    });
  }, [bookingInfo, totalAmount, showOfficialPriceOnDisplay]);
  const chakraStyles = {
    dropdownIndicator: (provided, state) => ({
      ...provided,
      p: 0,
      w: '20px',
    }),
    container: (provided, state) => ({
      ...provided,
      minWidth: '150px',
    }),
    control: (provided) => ({
      ...provided,
      fontSize: '0.75rem',
      minHeight: '32px',
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '0.75rem',
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: '0.75rem',
    }),
    option: (provided) => ({
      ...provided,
      fontSize: '0.75rem',
    }),
    input: (provided) => ({
      ...provided,
      fontSize: '0.75rem',
    }),
  };

  // Check if booking session exists on mount
  useEffect(() => {
    const checkAndRestoreSession = () => {
      // If no booking session, redirect to create page
      if (!selectedShow?.booking_session_id) {
        setShouldBlockNavigation(false);
        toast({
          title: 'Session not found',
          description: 'Booking session not found. Redirecting to booking page.',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
          onCloseComplete: () => {
            window.location.href = '/#/admin/booking/create';
          },
        });
        // Also redirect after 2 seconds if user doesn't close the toast
        setTimeout(() => {
          window.location.href = '/#/admin/booking/create';
        }, 2000);
      } else {
        // If session exists but URL is wrong (e.g., after F5 and back), restore correct URL
        const currentPath = window.location.hash;
        if (!currentPath.includes('/admin/booking/create/information') &&
            !currentPath.includes('/admin/booking/create/payment') &&
            !currentPath.includes('/admin/booking/create/detail/')) {
          // Silently restore the correct URL without triggering navigation
          window.history.replaceState(null, '', '/#/admin/booking/create/payment');
        }
      }
    };

    checkAndRestoreSession();
  }, []);

  useEffect(async () => {
    // Check if session is valid before making API calls
    if (!selectedShow?.booking?.show_schedule_detail_id || selectedShow?.booking?.show_schedule_detail_id === 0) {
      setShouldBlockNavigation(false);
      toast({
        title: 'Session Closed',
        description: 'Your booking session has been closed. Redirecting to booking page.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
      setTimeout(() => {
        window.location.href = '/#/admin/booking/create';
      }, 2000);
      return;
    }

    try {
      await bookingActions.getListChannel(
        {
          status: 1,
        },
        0,
        ''
      );
      await bookingActions.selectUnit({ unit_id: 0 });
      await bookingActions.getListPaymentStatus({ status: 1 }, 0, '');
      const {
        data: { data: bookingData },
      } = await bookingActions.getBookingInfo();

      // Check if booking data is valid
      if (!bookingData || !bookingData.calculator) {
        setShouldBlockNavigation(false);
        toast({
          title: 'Session Closed',
          description: 'Your booking session has been closed. Redirecting to booking page.',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        setTimeout(() => {
          window.location.href = '/#/admin/booking/create';
        }, 2000);
        return;
      }

      setValue('payment_status', 3);
      setBookingInfo(bookingData);
      const total = bookingData.calculator.reduce(
        (acc, curr) => acc + curr.amount,
        0
      );
      setTotalAmount(total);
      setTotalRemain(total);
      setValue('validity', '');
    } catch (error) {
      console.error('Error loading booking data:', error);
      setShouldBlockNavigation(false);
      toast({
        title: 'Session Closed',
        description: 'Your booking session has been closed. Redirecting to booking page.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
      setTimeout(() => {
        window.location.href = '/#/admin/booking/create';
      }, 2000);
    }
  }, []);

  useEffect(async () => {
    if (paymentStatus) {
      if (parseInt(paymentStatus) === 1) {
        const data = await bookingActions.getListPaymentMethod(
          { status: 1 },
          0,
          ''
        );
        setPaymentMethod(data);
      } else if (parseInt(paymentStatus) === 3) {
        setPaymentMethod([]);
      } else {
        setPaymentMethod([]);
      }
    }
  }, [paymentStatus]);

  useEffect(() => {
    if (channel) {
      if (isSettingChannelFromUnit.current) {
        isSettingChannelFromUnit.current = false;
        return;
      }
      setValue('unit', null);
      setSelectedRatePlan([]);
      setUnitSearchResults([]);
      setValue('unit_code', '');
      bookingActions.getListUnits({ channel_id: channel.id, status: 1 }, 0, '');
    }
  }, [channel]);

  useEffect(async () => {
    if (unit) {
      setIsLoaded(true);
      setSelectedRatePlan([]);
      try {
        await bookingActions.selectUnit({ unit_id: unit.id });
        const {
          data: { data: bookingData },
        } = await bookingActions.getBookingInfo();
        const {
          data: { data: ratePlanData },
        } = await ratePlanActions.getListRatePlansByShowTime({
          show_schedule_detail_id: selectedShow.booking.show_schedule_detail_id,
          unit_id: unit.id,
          zone_id: bookingData.seats[0].zone.id,
          child: bookingData.child,
          adult: bookingData.adult,
        });
        const {
          data: { data: listComboData },
        } = await ratePlanActions.getListComboByShowTime({
          show_schedule_detail_id: selectedShow.booking.show_schedule_detail_id,
          zone_id: bookingData.seats[0].zone.id,
          unit_id: unit.id,
          child: bookingData.child,
          adult: bookingData.adult,
        });
        const total = bookingData.calculator.reduce(
          (acc, curr) => acc + curr.amount,
          0
        );
        setListRatePlan(ratePlanData);
        clearErrors('rateplan');
        setListCombo(listComboData);
        setTotalAmount(total);
        setTotalRemain(total);
        setBookingInfo(bookingData);
      } catch (error) {
        toast({
          status: 'error',
          description: `Something wrong: ${error}`,
          position: 'top-right',
          duration: 5000,
        });
        setIsLoaded(false);
      }
      setIsLoaded(false);
      if (unit?.is_liability === 1) {
        setValue('payment_status', 2);
      }
    }
  }, [unit]);

  useEffect(async () => {
    if (deposit === 'yes') {
      const data = await bookingActions.getListPaymentMethod(
        { status: 1 },
        0,
        ''
      );
      setPaymentMethod(data);
      setValue('payment_status', 1);
    } else {
      setTotalRemain(totalAmount);
      setDepositValue(0);
    }
  }, [deposit]);

  useEffect(() => {
    if (depositValue) {
      const remain = parseInt(totalAmount) - depositValue;
      setTotalRemain(remain);
    }
  }, [depositValue]);

  // useEffect(() => {
  //   if(listUnit && listUnit.length > 0){
  //     console.log(listUnit,'listUnit')
  //     setValue("channel", listUnit[0].channel)
  //     // setListChannel(listUnit[0].channel)
  //   }
  // },[listUnit])

  useEffect(() => {
    if (paymentMethodWatch === 7) {
      setValue('payment_status', 1);
    }
  }, [paymentMethodWatch]);

  const scanQRCode = async (val) => {
    setValue('promotion_code', val);
    onClose();
    try {
      const res = await bookingActions.selectVoucher({
        voucher_code: val,
      });
      if (res.status === 200) {
        toast({
          status: 'success',
          description: 'Apply promotion code successful',
          position: 'top-right',
          duration: 2000,
        });
        updateBookingInfo();
      }
    } catch (error) {
      toast({
        status: 'error',
        description: `${error.response.data.meta.message}`,
        position: 'top-right',
        duration: 2000,
      });
      console.warn(error);
    }
  };

  function disableCamera() {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(function (stream) {
        // Get all video tracks from the stream
        const videoTracks = stream.getVideoTracks();

        // Disable each video track
        videoTracks.forEach(function (track) {
          track.enabled = false;
        });

        console.log('Camera disabled');
      })
      .catch(function (error) {
        console.log('Error disabling camera:', error);
      });
  }

  // Handle navigation blocking with custom dialog
  const handleBlockedNavigation = useCallback((location) => {
    // Allow navigation within booking flow (information and payment pages only)
    if (location.pathname === '/admin/booking/create/information' ||
        location.pathname === '/admin/booking/create/payment') {
      return true;
    }

    // Block navigation outside booking flow (including detail page) and show dialog
    setPendingLocation(location);
    setIsLeaveDialogOpen(true);
    return false;
  }, []);

  const handleConfirmLeave = async () => {
    setIsNavigating(true);
    try {
      await bookingActions.cancelBooking();
      resetCustomerDisplay();
      setShouldBlockNavigation(false);
      setIsLeaveDialogOpen(false);

      // Navigate to pending location after canceling
      const targetPath = pendingLocation?.pathname || '/admin/booking/create';
      setTimeout(() => {
        isProgrammaticNavigation.current = true;
        history.push(targetPath);
      }, 100);
    } catch (error) {
      console.error('Error canceling booking:', error);
      toast({
        description: 'Failed to cancel booking',
        status: 'error',
        duration: 3000,
        position: 'top-right',
      });
      setIsNavigating(false);
    }
  };

  const handleCancelLeave = () => {
    setIsLeaveDialogOpen(false);
    setPendingLocation(null);
  };

  const handleConfirmCancel = async () => {
    if (isCancelling) return;
    setIsCancelling(true);
    try {
      await bookingActions.cancelBooking();
      resetCustomerDisplay();
      setShouldBlockNavigation(false);
      setIsCancelDialogOpen(false);
      setTimeout(() => {
        history.push('/admin/booking/create');
      }, 100);
    } catch (error) {
      const errorMessage = error?.response?.data?.meta?.message || error?.message || 'Failed to cancel booking';
      toast({
        description: errorMessage,
        status: 'error',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });
      console.error('Error canceling booking:', error);
    } finally {
      setIsCancelling(false);
    }
  };

  // Handle popstate (browser back/forward buttons)
  useEffect(() => {
    const handlePopState = () => {
      // Allow back to information page (within booking flow)
      isProgrammaticNavigation.current = true;
      history.push('/admin/booking/create/information');
    };

    if (shouldBlockNavigation) {
      // Push current state to create history entry
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handlePopState);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [shouldBlockNavigation, history]);

  // Handle beforeunload event (refresh, close tab)
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (shouldBlockNavigation) {
        e.preventDefault();
        e.returnValue = 'Are you sure you want to leave this page? Your current selection has not been completed. If you leave now, you will need to start this step again.';
        return e.returnValue;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [shouldBlockNavigation]);

  const resetRatePlan = async () => {
    await bookingActions.selectUnit({ unit_id: unit.id });
    const {
      data: { data: bookingData },
    } = await bookingActions.getBookingInfo();
    setBookingInfo(bookingData);
    setSelectedRatePlan([]);
    setSelectedCombo([]);
  };

  const applyVoucher = async () => {
    try {
      const res = await bookingActions.selectVoucher({
        voucher_code: voucher_code,
      });
      if (res.status === 200) {
        toast({
          status: 'success',
          description: 'Apply promotion code successful',
          position: 'top-right',
          duration: 2000,
        });
        updateBookingInfo();
      }
    } catch (error) {
      toast({
        status: 'error',
        description: `${error.response.data.meta.message}`,
        position: 'top-right',
        duration: 2000,
      });
      console.warn(error);
    }
  };

  const searchUnit = async () => {
    const unitCode = watch('unit_code')?.replace(/\s/g, '');
    try {
      const res = await bookingActions.getListUnits(
        { code: unitCode, status: 1 },
        0,
        ''
      );
      const results = res.data.data;
      if (!results || results.length === 0) {
        toast({
          description: `No unit found for code "${unitCode}"`,
          status: 'warning',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        return;
      }
      if (results.length === 1) {
        isSettingChannelFromUnit.current = true;
        setValue('channel', results[0].channel);
        setValue('unit', results[0]);
        setUnitSearchResults([]);
        toast({
          description: `Found unit: ${results[0].name}`,
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      } else {
        setUnitSearchResults(results);
        setValue('unit', null);
        setValue('channel', null);
        toast({
          description: `Found ${results.length} units. Please select one.`,
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      }
    } catch (error) {
      toast({
        description: error?.response?.data?.meta?.message || 'Failed to search unit',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
    }
  };

  const onSelectedRatePlan = async (val) => {
    try {
      const res = await bookingActions.selectRatePlan({
        rateplan_detail_id: val,
      });
      let ratePlanSelected = [];
      let currentValue = [...selectedRatePlan, val];
      if (res.data.data.rateplan_remove.length > 0) {
        ratePlanSelected = currentValue.filter(
          (value) => !res.data.data.rateplan_remove.includes(value)
        );
      } else {
        ratePlanSelected = currentValue;
      }
      if (selectedRatePlan.includes(val)) {
        setSelectedRatePlan((prevState) =>
          prevState.filter((ratePlan) => ratePlan !== val)
        );
      } else {
        setSelectedRatePlan(ratePlanSelected);
      }
      currentValue = [];
      if (res.status === 200) {
        clearErrors('rateplan');
        updateBookingInfo();
      }
    } catch (error) {
      toast({
        description: `${error?.response?.data?.meta?.message}`,
        status: 'error',
        position: 'top-right',
        duration: 2000,
      });
    }
  };

  const updateBookingInfo = async () => {
    const {
      data: { data: bookingData },
    } = await bookingActions.getBookingInfo();
    const total = bookingData.calculator.reduce(
      (acc, curr) => acc + curr.amount,
      0
    );
    setTotalAmount(total);
    setTotalRemain(total);
    setBookingInfo(bookingData);
    if (parseInt(total) === 0) {
      setValue('payment_status', 1);
      setValue('payment_method', 7);
    }
    if (parseInt(total) !== 0 && unit?.is_liability === 2) {
      setValue('payment_status', 3);
    } else if (unit?.is_liability === 1 && parseInt(total) !== 0) {
      setValue('payment_status', 2);
    }
  };

  const onSelectedCombo = async (val) => {
    if (selectedCombo === val.id && !val.updateQuantity) return;
    setSelectedCombo(val.id);
    const res = await bookingActions.selectCombo({
      rateplan_detail_id: val.id,
      quantity: val.quantity,
    });
    let ratePlanSelected = [];
    let currentValue = [...selectedRatePlan];
    if (res.data.data.rateplan_remove.length > 0) {
      ratePlanSelected = currentValue.filter(
        (value) => !res.data.data.rateplan_remove.includes(value)
      );
    } else {
      ratePlanSelected = currentValue;
    }
    if (selectedRatePlan.includes(val)) {
      setSelectedRatePlan((prevState) =>
        prevState.filter((ratePlan) => ratePlan !== val)
      );
    } else {
      setSelectedRatePlan(ratePlanSelected);
    }
    currentValue = [];
    if (res.status === 200) {
      updateBookingInfo();
    }
  };

  const { errors, isSubmitting } = formState;
  async function onSubmit({ notes, validity, payment_status, payment_method }) {
    if (voucher_code && !unit) {
      return;
    }
    if (!unit) {
      setError('unit', { message: 'Please select Unit for this booking' });
      return;
    }
    const checkSelectedRatePlan = bookingInfo?.calculator?.every(
      (i) => i.program_apply
    );
    if (!checkSelectedRatePlan && !voucher_code) {
      setError('rateplan', {
        message: 'Please select Rate Plan for this booking',
      });
      return;
    }
    // if (payment_status == 3 && (!validity || validity.length === 0)) {
    //   setError("validity", {
    //     message: "Please select validity for this booking",
    //   });
    //   return;
    // }
    let params = {
      notes,
      deposit: depositValue || 0,
      payment_status: parseInt(payment_status),
    };
    if (parseInt(payment_status) === 1) {
      params.payment_method = parseInt(payment_method);
    }
    if (validity) {
      params.validity = validity.toISOString();
    }
    try {
      const res = await bookingActions.createBooking(params);
      if (res.status === 200) {
        toast({
          description: 'Well done',
          duration: 2000,
          status: 'success',
        });
        customerDisplayChannelRef.current?.postMessage({
          type: 'booking-code',
          code: res.data.data.code,
        });
        setShouldBlockNavigation(false);
        setTimeout(() => {
          history.push(`/admin/booking/create/detail/${res.data.data.id}`);
        }, 100);
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.meta?.message || error?.message || 'An error occurred while creating booking';
      toast({
        description: errorMessage,
        status: 'error',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });
    }
  }

  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);
    let showDate = new Date(bookingInfo?.show_date);
    let [hours, minutes, seconds] = bookingInfo?.show_time
      .split(':')
      .map(Number);
    showDate.setHours(hours);
    showDate.setMinutes(minutes);
    showDate.setSeconds(seconds);
    return (
      new Date(time).getTime() < showDate.getTime() &&
      currentDate.getTime() < selectedDate.getTime()
    );
  };

  const filterDate = (date) => {
    let showDate = new Date(bookingInfo?.show_date);
    showDate.setHours(0, 0, 0, 0);

    let currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    let targetDate = new Date(date);
    targetDate.setHours(0, 0, 0, 0);

    return targetDate >= currentDate && targetDate <= showDate;
  };

  const isRequiredValidity = () => {
    return paymentStatus === 3;
  };

  return (
    <>
      <Prompt
        when={shouldBlockNavigation}
        message={handleBlockedNavigation}
      />
      <form
        onSubmit={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') e.preventDefault();
        }}
      >
        <Card>
          <CardBody>
            <Stack direction='column' spacing='20px' w='100%'>
              <Flex
                direction={{ sm: 'column', md: 'row' }}
                gap={{ sm: '10px', lg: '30px' }}
                w={{ lg: '50%', md: '100%' }}
                flexWrap='wrap'
              >
                <FormControl w='300px' flex='0 0 auto' maxW='100%'>
                  <FormLabel fontWeight='bold' mb='10px' fontSize='md'>
                    Channel
                  </FormLabel>
                  <Controller
                    name='channel'
                    control={control}
                    render={({ field }) => (
                      <ReSelect
                        {...field}
                        focusBorderColor='blue.500'
                        chakraStyles={chakraStyles}
                        options={listChannel}
                        placeholder='Select Channel'
                        getOptionLabel={(i) => i.name}
                        getOptionValue={(option) => option.id}
                        size='sm'
                        closeMenuOnSelect={true}
                      />
                    )}
                  />
                </FormControl>
                <FormControl w='300px' flex='0 0 auto' maxW='100%'>
                  <FormLabel fontWeight='bold' mb='10px' fontSize='md'>
                    Unit Code
                  </FormLabel>
                  <Flex align='center'>
                    <Input
                      type='text'
                      placeholder='Unit Code'
                      name='unit_code'
                      {...register('unit_code')}
                      isInvalid={errors.unit_code}
                      errorBorderColor='red.300'
                      maxW='200px'
                      sx={{
                        height: '32px !important',
                        minHeight: '32px !important',
                        fontSize: '13px !important',
                      }}
                    />
                    <Button
                      size='sm'
                      minW='110px'
                      colorScheme='blue'
                      ml={{ lg: 4, sm: 1 }}
                      fontSize='base'
                      onClick={() => searchUnit()}
                    >
                      Search Unit
                    </Button>
                  </Flex>
                </FormControl>

                <FormControl isRequired w='300px' flex='0 0 auto' maxW='100%'>
                  <Box>
                    <FormLabel fontWeight='bold' mb='10px' fontSize='md'>
                      Unit
                    </FormLabel>
                    <Controller
                      name='unit'
                      control={control}
                      render={({ field }) => (
                        <ReSelect
                          {...field}
                          focusBorderColor='blue.500'
                          chakraStyles={chakraStyles}
                          options={unitSearchResults.length > 0 ? unitSearchResults : listUnit}
                          placeholder='Select Unit'
                          getOptionLabel={(i) => i.name}
                          getOptionValue={(option) => option.id}
                          size='sm'
                          closeMenuOnSelect={true}
                          onChange={(selected) => {
                            field.onChange(selected);
                            if (selected && unitSearchResults.length > 0) {
                              isSettingChannelFromUnit.current = true;
                              setValue('channel', selected.channel);
                            }
                          }}
                        />
                      )}
                    />
                    <Text color='red' fontSize={14} mb='10px' ml='5px'>
                      {errors.unit?.message}
                    </Text>
                  </Box>
                </FormControl>
              </Flex>
              <Flex direction='column'>
                {isLoaded ? (
                  <Flex direction='column' mt='32px' gap={4}>
                    <FormLabel fontWeight='bold' mb='10px' fontSize='md'>
                      Rate Plan
                    </FormLabel>
                    <Grid
                      templateColumns={{
                        sm: '1fr',
                        md: 'repeat(2, 1fr)',
                        lg: 'repeat(4, 1fr)',
                      }}
                      gap='30px'
                      cursor='pointer'
                    >
                      <Skeleton height='188px' fadeDuration={1}></Skeleton>
                      <Skeleton height='188px' fadeDuration={1}></Skeleton>
                      <Skeleton height='188px' fadeDuration={1}></Skeleton>
                      <Skeleton height='188px' fadeDuration={1}></Skeleton>
                    </Grid>
                  </Flex>
                ) : (
                  <Flex direction='column' mt='32px' gap={2}>
                    <Flex>
                      <FormLabel fontWeight='bold' fontSize='md'>
                        Rate Plan
                      </FormLabel>
                    </Flex>
                    <Flex>
                      <Text color='red' fontSize='sm'>
                        {errors.rateplan?.message}
                      </Text>
                    </Flex>

                    {listRatePlan.length > 0 && (
                      <Grid
                        templateColumns={{
                          sm: '1fr',
                          md: 'repeat(2, 1fr)',
                          lg: 'repeat(4, 1fr)',
                        }}
                        gap='30px'
                        cursor='pointer'
                      >
                        {listRatePlan.map((i, index) => (
                          <RatePlanCard
                            key={index}
                            item={i}
                            bookingInfo={bookingInfo}
                            selectedRatePlan={selectedRatePlan}
                            onSelect={(val) => onSelectedRatePlan(val)}
                          />
                        ))}
                      </Grid>
                    )}
                  </Flex>
                )}
                {isLoaded ? (
                  <Flex direction='column' mt='32px' gap={4}>
                    <FormLabel fontWeight='bold' fontSize='md'>
                      Combo
                    </FormLabel>
                    <Grid
                      templateColumns={{
                        sm: '1fr',
                        md: 'repeat(2, 1fr)',
                        lg: 'repeat(4, 1fr)',
                      }}
                      gap='30px'
                      cursor='pointer'
                    >
                      <Skeleton height='124px' fadeDuration={1}></Skeleton>
                      <Skeleton height='124px' fadeDuration={1}></Skeleton>
                      <Skeleton height='124px' fadeDuration={1}></Skeleton>
                      <Skeleton height='124px' fadeDuration={1}></Skeleton>
                    </Grid>
                  </Flex>
                ) : (
                  listCombo.length > 0 && (
                    <Flex direction='column' mt='32px' gap={2}>
                      <Flex>
                        <FormLabel fontWeight='bold' mb='10px' fontSize='md'>
                          Combo
                        </FormLabel>
                      </Flex>
                      <Grid
                        templateColumns={{
                          sm: '1fr',
                          md: 'repeat(2, 1fr)',
                          lg: 'repeat(4, 1fr)',
                        }}
                        gap='30px'
                        cursor='pointer'
                      >
                        {listCombo.map((i, index) => (
                          <ComboCard
                            bookingInfo={bookingInfo}
                            key={index}
                            item={i}
                            isSelected={
                              i.rateplan_configs.length > 0
                                ? i?.rateplan_configs[0]?.id === selectedCombo
                                : false
                            }
                            onSelect={(val) => onSelectedCombo(val)}
                          />
                        ))}
                      </Grid>
                    </Flex>
                  )
                )}
              </Flex>
              <Stack
                maxW={{ lg: '50%', sm: '100%' }}
                direction={{ sm: 'column', md: 'row' }}
                spacing='30px'
              >
                <FormControl>
                  <FormLabel fontWeight='bold' mb='10px' fontSize='md'>
                    Promotion Code
                  </FormLabel>
                  <Flex align='center'>
                    <Input
                      type='text'
                      placeholder='Promotion Code'
                      name='promotion_code'
                      {...register('promotion_code')}
                      isInvalid={errors.promotion_code}
                      errorBorderColor='red.300'
                      maxW='200px'
                      onKeyUp={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          applyVoucher();
                        }
                      }}
                      sx={{
                        height: '32px !important',
                        minHeight: '32px !important',
                        fontSize: '14px !important',
                      }}
                    />
                    <QrCodeIConMobile
                      style={{
                        cursor: 'pointer',
                      }}
                      ml={{ sm: '6px', lg: '24px' }}
                      w={{ sm: '24px', lg: '32px' }}
                      h={{ sm: '24px', lg: '32px' }}
                      onClick={() => {
                        setShowQRCode(true);
                        onOpen();
                      }}
                    />
                    <Button
                      size='sm'
                      colorScheme='blue'
                      ml={{ lg: 4, sm: 1 }}
                      fontSize='base'
                      px={5}
                      py={2}
                      onClick={() => applyVoucher()}
                    >
                      Apply Code
                    </Button>
                  </Flex>
                </FormControl>
              </Stack>
              {listRatePlan.length > 0 && unit && (
                <Button
                  maxW='120px'
                  size='sm'
                  onClick={() => resetRatePlan()}
                  colorScheme='blue'
                >
                  Reset Rate Plan
                </Button>
              )}
            </Stack>
          </CardBody>
        </Card>

        <Card overflowX={{ sm: 'scroll', xl: 'hidden' }} mt='20px'>
          <CardBody>
            <Table variant='simple' color={textColor}>
              <Thead>
                <Tr my='.8rem' pl='0px' color='gray.400'>
                  <Th borderColor={borderColor} color='gray.400'>
                    Channel
                  </Th>
                  <Th borderColor={borderColor} color='gray.400'>
                    Unit
                  </Th>
                  <Th borderColor={borderColor} color='gray.400'>
                    Program Applied
                  </Th>
                  <Th borderColor={borderColor} color='gray.400'>
                    Seat
                  </Th>
                  <Th borderColor={borderColor} color='gray.400'>
                    Floor
                  </Th>
                  <Th borderColor={borderColor} color='gray.400'>
                    Zone
                  </Th>
                  <Th borderColor={borderColor} color='gray.400'>
                    Official Price
                  </Th>
                  <Th borderColor={borderColor} color='gray.400'>
                    Amount
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {bookingInfo &&
                  bookingInfo?.calculator?.map((row, index, arr) => {
                    return (
                      <React.Fragment key={index}>
                        <TablesTableRow
                          row={row}
                          paddingY={'0px'}
                          isLast={index === arr.length - 1 ? true : false}
                        />
                      </React.Fragment>
                    );
                  })}
              </Tbody>
            </Table>
          </CardBody>
          <Flex align='flex-end' justify='flex-end' mt={3}>
            <Flex minW={{ xl: '480px' }} direction='column'>
              <Flex align='center' justify='space-between'>
                <Text>Total Amount of this booking:</Text>
                <Text>{totalAmount.toLocaleString('en-US')} VND</Text>
              </Flex>
              <HSeparator my={2} />
              <Flex align='center' justify='space-between'>
                <Flex direction='column'>
                  <Text>Do you want to do a deposit?</Text>
                </Flex>
                <Flex direction='column'>
                  <Controller
                    name='deposit'
                    control={control}
                    defaultValue='no'
                    render={({ field: { onChange, value } }) => (
                      <RadioGroup onChange={onChange} value={value}>
                        <Stack
                          direction='row'
                          spacing={2}
                          justifyContent='flex-end'
                        >
                          <Radio value='no'>No</Radio>
                          <Radio value='yes'>Yes</Radio>
                        </Stack>
                      </RadioGroup>
                    )}
                  />
                  <NumericFormat
                    customInput={Input}
                    thousandSeparator=','
                    fontSize='sm'
                    ms='4px'
                    size='sm'
                    defaultValue={0}
                    disabled={deposit === 'no'}
                    value={depositValue}
                    onValueChange={(values) =>
                      setDepositValue(values.floatValue)
                    }
                    textAlign='right'
                    isAllowed={(values) => {
                      const { floatValue } = values;
                      return floatValue < totalAmount;
                    }}
                  />
                </Flex>
              </Flex>
              <HSeparator my={2} />
              <Flex align='center' justify='space-between'>
                <Text>Deposit:</Text>
                {deposit === 'yes' && (
                  <Text>{depositValue.toLocaleString('en-US')} VND</Text>
                )}
              </Flex>
              <HSeparator my={2} />
              <Flex align='center' justify='space-between'>
                <Text>Remaining:</Text>
                <Text>{totalRemain.toLocaleString('en-US')} VND</Text>
              </Flex>
            </Flex>
          </Flex>
        </Card>

        <Card p='16px' my={{ sm: '24px', xl: '25px' }} mt={{ lg: '45px' }}>
          <CardHeader p='12px 5px'>
            <Text fontSize='lg' color={textColor} fontWeight='bold'>
              Preview & Payment
            </Text>
          </CardHeader>
          <CardBody px='5px'>
            <Grid
              templateColumns={{
                lg: '30% auto',
                md: 'repeat(1, 1fr)',
              }}
              gap='30px'
            >
              <Flex direction='column' gridColumn={1}>
                <Flex align='center' mb='18px'>
                  <Text
                    fontSize='md'
                    color={textColor}
                    fontWeight='bold'
                    me='10px'
                    minW={{ base: '100px', lg: '150px' }}
                  >
                    Total:
                  </Text>
                  <Text fontSize='base' fontWeight='bold'>
                    {deposit === 'no'
                      ? totalAmount.toLocaleString('en-US')
                      : depositValue.toLocaleString('en-US')}{' '}
                    VND
                  </Text>
                </Flex>
                <Flex mb='18px' align='center'>
                  <Text
                    fontSize='md'
                    color={textColor}
                    fontWeight='bold'
                    me='10px'
                    minW={{ base: '100px', lg: '150px' }}
                  >
                    Payment Status:
                  </Text>
                  <Select
                    variant='main'
                    size='sm'
                    name='payment_status'
                    {...register('payment_status')}
                    sx={{
                      fontSize: '0.75rem !important',
                      height: '32px !important',
                    }}
                  >
                    {listPaymentStatus.map((item, index) => (
                      <option
                        key={index}
                        value={item.id}
                        disabled={
                          (parseInt(item.id) === 2 &&
                            unit?.is_liability !== 1) ||
                          (parseInt(item.id) === 3 && deposit === 'yes')
                        }
                      >
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </Flex>
                {(parseInt(paymentStatus) === 3 || deposit === 'yes') && (
                  <>
                    <Flex mb={4} width='100%' align='center'>
                      <Text
                        fontSize='md'
                        color={textColor}
                        fontWeight='bold'
                        me='10px'
                        minW={{ base: '100px', lg: '150px' }}
                      >
                        Validity:
                      </Text>
                      <Box
                        w='100%'
                        sx={{
                          '& .chakra-input': {
                            width: '100% !important',
                          },
                        }}
                      >
                        {bookingInfo && (
                          <Controller
                            name='validity'
                            control={control}
                            render={({ field }) => (
                              <ReactDatePicker
                                {...field}
                                autoComplete={'off'}
                                calendarStartDay={1}
                                filterTime={filterPassedTime}
                                customInput={<Input />}
                                showTimeSelect
                                selected={field?.value}
                                dateFormat='dd/MM/yyyy hh:mm aa'
                                timeFormat='hh:mm aa'
                                className='booking-date-range-search'
                                closeOnScroll={false}
                                filterDate={filterDate}
                                onChange={(value) => {
                                  field.onChange(value);
                                }}
                                // required={isRequiredValidity()}
                              />
                            )}
                          />
                        )}
                      </Box>
                    </Flex>
                    <Flex mb={4} width='100%' align='center'>
                      <Text color='red' fontSize='sm'>
                        {errors.validity?.message}
                      </Text>
                    </Flex>
                  </>
                )}
                {paymentMethod.length > 0 && (
                  <Flex mt={2} mb={4} width='100%' align='center'>
                    <Text
                      fontSize='md'
                      color={textColor}
                      fontWeight='bold'
                      me='10px'
                      minW={{ base: '100px', lg: '150px' }}
                    >
                      Payment Method:
                    </Text>
                    <Select
                      variant='main'
                      fontSize='xs'
                      size='sm'
                      defaultValue={0}
                      name='payment_method'
                      {...register('payment_method')}
                    >
                      {paymentMethod.map((i) => (
                        <option key={i.id} value={i.id}>
                          {i.name}
                        </option>
                      ))}
                    </Select>
                  </Flex>
                )}
                <Flex align='center'>
                  <Text
                    fontSize='md'
                    color={textColor}
                    fontWeight='bold'
                    me='10px'
                    minW={{ base: '100px', lg: '150px' }}
                  >
                    Booking Notes:
                  </Text>
                  <Textarea rows={4} {...register('notes')} name='notes' />
                </Flex>
              </Flex>
              <Flex justifyContent='space-around'>
                <Grid
                  templateColumns={{
                    sm: '1fr',
                    lg: 'repeat(2, auto)',
                  }}
                  gap={4}
                >
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Show Name:
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingInfo?.show?.name}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Venue:
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingInfo?.venue?.name}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Show Date:
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {moment(bookingInfo?.show_date).format('DD/MM/YYYY')}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Show Time:
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingInfo?.show_time.slice(0, -3)}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Address:
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingInfo?.venue?.address}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Seat No.:
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingInfo?.seats
                        ?.map((seat) => seat.seat_number)
                        .join(', ')}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Adult:
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingInfo?.adult}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Child (5 - 12 ages):
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingInfo?.child}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Zone:
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {bookingInfo?.seats?.[0]?.zone?.name}
                    </Text>
                  </Flex>
                  <Flex align='center' gap={2}>
                    <Text
                      fontSize='base'
                      color='#718096'
                      minW={{ base: '100px', lg: '110px' }}
                    >
                      Floor:
                    </Text>
                    <Text fontWeight='bold' fontSize='base'>
                      {showTextFloor(bookingInfo?.seats?.[0]?.floor)}
                    </Text>
                  </Flex>
                </Grid>
              </Flex>
            </Grid>
            <Flex align='center' justify='center' gap={4} mt={4}>
              <Button 
                colorScheme='blue' 
                mr={3} 
                type='submit'
                isLoading={isSubmitting}
                disabled={isSubmitting}
              >
                Proceed
              </Button>
              <Button
                onClick={() => setIsCancelDialogOpen(true)}
                isLoading={isCancelling}
                disabled={isCancelling}
              >
                Cancel Booking
              </Button>
            </Flex>
          </CardBody>
        </Card>

        {selectedShow?.booking && (
          <Portal>
            <Box>
              <CountDown
                expTime={selectedShow.booking.expire_at}
                onExpire={() => {
                  setShouldBlockNavigation(false);
                  resetCustomerDisplay();
                }}
              />
            </Box>
          </Portal>
        )}
      </form>
      {showQRCode && (
        <>
          <Modal
            isOpen={isOpen}
            onClose={() => {
              onClose();
              disableCamera();
            }}
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Scan QR</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <QrScanner
                  onDecode={(result) => scanQRCode(result)}
                  onError={(error) => alert(error?.message)}
                />
              </ModalBody>
            </ModalContent>
          </Modal>
        </>
      )}
      <AlertDialog
        isOpen={isLeaveDialogOpen}
        leastDestructiveRef={leaveRef}
        onClose={handleCancelLeave}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent bg='white' borderRadius='12px' px={4} py={4} maxW='420px' w='90%'>
            <IconButton
              aria-label='Close dialog'
              icon={<CloseIcon />}
              position='absolute'
              top={3}
              right={3}
              onClick={handleCancelLeave}
              borderRadius='full'
              border='2px solid'
              borderColor='blue.100'
              bg='white'
              _hover={{ bg: 'gray.50' }}
              size='sm'
            />

            <AlertDialogHeader fontSize='lg' fontWeight='700' color='#0DB34A' textAlign='left'>
              Leave Payment Page
            </AlertDialogHeader>

            <AlertDialogBody pt={2} pb={4} color='gray.700' fontSize='sm' textAlign='left'>
              Are you sure you want to leave this page? Your current selection has not been completed. If you leave now, you will need to start this step again.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={leaveRef}
                onClick={handleCancelLeave}
                bg='gray.100'
                _hover={{ bg: 'gray.200' }}
                color='gray.800'
                borderRadius='10px'
                px={4}
                py={2}
                size='sm'
              >
                Stay
              </Button>
              <Button
                bg='#053957'
                color='white'
                ml={3}
                onClick={handleConfirmLeave}
                isLoading={isNavigating}
                _hover={{ bg: '#042e45' }}
                borderRadius='10px'
                px={4}
                py={2}
                size='sm'
              >
                Leave & Cancel Booking
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <AlertDialog
        isOpen={isCancelDialogOpen}
        leastDestructiveRef={cancelRef}
        onClose={() => setIsCancelDialogOpen(false)}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent bg='white' borderRadius='12px' px={4} py={4} maxW='420px' w='90%'>
            <IconButton
              aria-label='Close dialog'
              icon={<CloseIcon />}
              position='absolute'
              top={3}
              right={3}
              onClick={() => setIsCancelDialogOpen(false)}
              borderRadius='full'
              border='2px solid'
              borderColor='blue.100'
              bg='white'
              _hover={{ bg: 'gray.50' }}
              size='sm'
            />

            <AlertDialogHeader fontSize='lg' fontWeight='700' color='#0DB34A' textAlign='left'>
              Cancel Booking
            </AlertDialogHeader>

            <AlertDialogBody pt={2} pb={4} color='gray.700' fontSize='sm' textAlign='left'>
              Are you sure you want to cancel this booking?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                onClick={() => setIsCancelDialogOpen(false)}
                bg='gray.100'
                _hover={{ bg: 'gray.200' }}
                color='gray.800'
                borderRadius='10px'
                px={4}
                py={2}
                size='sm'
              >
                No
              </Button>
              <Button
                bg='#053957'
                color='white'
                ml={3}
                onClick={handleConfirmCancel}
                isLoading={isCancelling}
                _hover={{ bg: '#042e45' }}
                borderRadius='10px'
                px={4}
                py={2}
                size='sm'
              >
                Yes
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <CustomerDisplayPreview />
    </>
  );
}
export default BookingPayment;
